import Link from 'next/link';

const ShippingInfo = ({ className }) => {
  return (
    <div className={className}>
      Free Shipping on All Orders & 30-Day Free Return & Refund. Find more information:{' '}
      <Link
        className='uppercase underline'
        href='/shipping-return-policy'
      >
        Learn More
      </Link>
    </div>
  );
};

export default ShippingInfo;
